module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d/main_pc_e44f9b44a0ed47243ff325f121c5366b.jpg";